<template lang="pug">
include ./../../../mixins
+b.el-pagination
  +b.g-row.--align_center.--justify_center.--space_5xl.--space_8xl-md
    +b.g-cell.g-cols.--narrow-xs(
      v-if="hasPrev()"
    )
      +b.pagination-item.--arrow.left(
        @click="changePage(prevPage)"
      )
        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
        <g opacity="0.3">
        <path d="M30.875 19.5L8.125 19.5" stroke="white"
        | stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.5 30.875L8.125 19.5L19.5 8.125"
        | stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        </svg>
    +b.g-cell.g-cols.--narrow-xs
      +b.g-row.--align_center.--justify_center
        +b.g-cell.g-cols.--narrow-xs
          +b.g-row.--align_center.--space_5xl
            +b.g-cell.g-cols.--narrow-xs(
              v-for="page in pages"
              :key="page"
            )
              +b.pagination-item(
                :class="{'is-active' : currentPage === page }"
                @click="changePage(page)"
              )
                +b.P.ds-caption.--c_white.--size_md.--w_l.--op-4 {{ page }}
    +b.g-cell.g-cols.--narrow-xs(
      v-if="hasNext()"
    )
      +b.pagination-item.--arrow.right(
        @click="changePage(nextPage)"
      )
        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
        <g opacity="0.3">
        <path d="M8.125 19.5L30.875 19.5" stroke="white"
        | stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.5 30.875L30.875 19.5L19.5 8.125"
        | stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        </svg>
</template>

<script>
export default {
  name: 'uiLimitPagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 9,
    },
    pageRange: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      page_size: 4,
      limit: 500,
      show: true,
      zero: 0,
      one: 1,
    }
  },
  mounted() {
    const pages = []
    for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
      pages.push(i)
    }
    return pages
  },
  computed: {
    pages() {
      const pages = []
      for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
        pages.push(i)
      }
      return pages
    },
    rangeStart() {
      const start = this.currentPage - this.pageRange
      return (start > this.zero) ? start : this.one
    },
    rangeEnd() {
      const end = this.currentPage + this.pageRange
      return (end < this.totalPages) ? end : this.totalPages
    },
    totalPages() {
      return Math.ceil(this.total / this.perPage)
    },
    showDots() {
      const obj = {
        next: this.totalPages - this.currentPage,
        prev: this.one - this.currentPage,
      }
      return obj
    },
    nextPage() {
      return this.currentPage + this.one
    },
    prevPage() {
      return this.currentPage - this.one
    },
  },
  methods: {
    hasFirst() {
      return this.rangeStart !== this.one
    },
    hasLast() {
      return this.rangeEnd < this.totalPages
    },
    hasPrev() {
      return this.currentPage > this.one
    },
    hasNext() {
      return this.currentPage < this.totalPages
    },
    changePage(page) {
      this.$emit('page', page)
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/UiLimitPagination.vue